import { useNavigate } from 'react-router';

import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';

import {
  type DashboardTutorial,
  TUTORIAL_ASSET_DOWNLOAD_FILENAME,
} from '../tutorials';

export type TutorialCardProps = DashboardTutorial;

export default function TutorialCard({
  title,
  body,
  ctaText,
  ctaHref,
  assetDownloadHref,
  thumbnailSrc,
}: TutorialCardProps) {
  const navigate = useNavigate();

  return (
    <article className="border-primary bg-primary flex w-full max-w-[500px] flex-col gap-6 self-start rounded-2xl border p-4 sm:flex-row sm:items-start">
      <div className="bg-tertiary aspect-square w-full flex-none overflow-hidden rounded-lg sm:w-[225px]">
        <video
          src={thumbnailSrc}
          className="h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          disablePictureInPicture
          aria-hidden
        />
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-6">
        <div className="flex flex-col gap-2 pb-3">
          <Text
            as="h2"
            token="16/medium"
            className="text-primary pt-1 pb-2 text-pretty"
          >
            {title}
          </Text>
          <Text token="16" className="text-tertiary text-pretty">
            {body}
          </Text>
        </div>

        <div className="flex w-full flex-col items-center gap-3">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="w-full"
            onClick={() => {
              navigate(ctaHref);
            }}
          >
            {ctaText}
          </Button>

          <a
            href={assetDownloadHref}
            download={TUTORIAL_ASSET_DOWNLOAD_FILENAME}
            rel="noopener"
            className="text-blue hover:underline"
          >
            <Text token="14/medium">Download tutorial assets</Text>
          </a>
        </div>
      </div>
    </article>
  );
}
